import { Observable, timer } from 'rxjs';
import { map } from 'rxjs/internal/operators';
import * as socketIO from 'socket.io-client';
import { lazyInject, provideSingleton } from '../../inversify';
import Configuration from '../configuration';

type IPingMetadataFunction = () => { [key: string]: number };

@provideSingleton(PingService)
class PingService {
  @lazyInject(Configuration)
  private readonly configuration: Configuration;

  public ping(topic: string, metadataFunction: IPingMetadataFunction): Observable<void> {
    const socket = socketIO(this.configuration.socketIoEndpoint(), {
      path: this.configuration.socketIoPath(),
      query: {
        topic,
        type: 'ping',
        version: process.env.REACT_APP_VERSION,
      },
    });

    // Execute each 15 seconds
    return timer(0, 15000)
      .pipe(
        map(() => {
          socket.emit('status', metadataFunction());
        }));
  }
}

export default PingService;



// WEBPACK FOOTER //
// ./src/api/stadtbus/ping_service.ts